import { state } from "scripts/app";
import { MessageToast } from "scripts/ui/components/toast";

export class CoordsControls {
    // Широта, долгота, азимут
    latInput: HTMLInputElement;
    lngInput: HTMLInputElement;
    azimuthInput: HTMLInputElement;


    constructor() {
        const latInput = document.getElementById('startLatInput');
        const lngInput = document.getElementById('startLngInput');
        const azimuthInput = document.getElementById('azimuthInput');


        if (!(latInput instanceof HTMLInputElement) ||
            !(lngInput instanceof HTMLInputElement) ||
            !(azimuthInput instanceof HTMLInputElement)
        ) {
            throw new Error('Ошибка! Отсутствует поле ввода в блоке управления!');
        }

        this.latInput = latInput;
        this.lngInput = lngInput;
        this.azimuthInput = azimuthInput;

        this.addEventListeners();
    }

    private addEventListeners() {
        this.latInput.addEventListener('change', () => this.changeCoords());
        this.lngInput.addEventListener('change', () => this.changeCoords());
        this.latInput.addEventListener('input', () => this.changeCoords());
        this.lngInput.addEventListener('input', () => this.changeCoords());

        this.azimuthInput.addEventListener('change', () => this.changeAzimuth());
        this.azimuthInput.addEventListener('input', () => this.changeAzimuth());
    }

    public changeCoords() {
        if (!state.detector) {
            MessageToast.showDanger('Отсутствует сектор');
            return;
        }

        const lat = parseFloat(this.latInput.value);
        const lng = parseFloat(this.lngInput.value);

        if (isNaN(lat) || isNaN(lng)) return;

        // Перерисовка датчика
        state.detector.setLatLng(lat, lng);
    }

    private changeAzimuth() {
        if (!state.detector) {
            MessageToast.showDanger('Отсутствует сектор');
            return;
        }

        const value = parseFloat(this.azimuthInput.value);
        if (isNaN(value)) return;

        state.detector.azimuth = value;

        if(!state.detector.sector) return;
        state.detector.sector.azimuth = value;
        
        state.detector.sector?.redraw();
        console.log("Новый азимут:", value);
    }

    public setCoords(lat: number | null, lng: number | null) {
        if (!lat || !lng){
            this.latInput.value = '---';
            this.lngInput.value = '---';
            return;    
        }
        this.latInput.value = lat.toFixed(6);
        this.lngInput.value = lng.toFixed(6);
    }

    public setNullCoords() {
        this.latInput.value = "";
        this.lngInput.value = "";
    }

    public setAzimuth(azimuth: number | null) {
        if (!azimuth){
            this.azimuthInput.value = '---';
            return;
        }
        this.azimuthInput.value = azimuth.toFixed(6);
    }

    public setNullAzimuth() {
        this.azimuthInput.value = "";
    }

}